import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const TicketList = styled.ul(() =>
  mq({
    marginBottom: [0, 0, 0, 0, defaultTheme.spacing.xxl],
    maxHeight: ['initial', 'initial', 'initial', 'initial', '350px'],
    overflowY: 'auto',
    overflowX: 'hidden',
    width: ['initial', 'initial', 'initial', 'initial', '256px'],
  }),
);

export const ListItem = styled.li(() =>
  mq({
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      0,
    ],
    marginBottom: [0, 0, 0, 0, defaultTheme.spacing.m],
    borderBottom: [
      `solid ${defaultTheme.border.color.lightGray}`,
      `solid ${defaultTheme.border.color.lightGray}`,
      `solid ${defaultTheme.border.color.lightGray}`,
      `solid ${defaultTheme.border.color.lightGray}`,
      'none',
    ],
    borderBottomWidth: [defaultTheme.spacing.xs, defaultTheme.spacing.xs, 0, 0],
  }),
);

export const SummaryWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: ['center', 'center', 'center', 'center', 'flex-start'],
    justifyContent: 'space-between',
    width: ['100%', '100%', '100%', '100%', '238px'],
    borderBottom: `1px solid ${defaultTheme.border.color.lightGray}`,
    padding: `${defaultTheme.spacing.l} 0`,
    ':first-of-type': {
      paddingTop: '0',
    },
  }),
);

export const Details = styled.div(() =>
  mq({
    display: 'grid',
    gridGap: [
      `${defaultTheme.spacing.xs} 0`,
      `${defaultTheme.spacing.xs} 0`,
      `${defaultTheme.spacing.s} 0`,
      `${defaultTheme.spacing.s} 0`,
    ],
  }),
);

export const Detail = styled.div(() =>
  mq({
    width: ['100%', '100%', '70px', '70px'],
    fontSize: defaultTheme.font.size.s,
    wordBreak: 'keep-all',
  }),
);

export const SetNumWrapper = styled.div(() =>
  mq({
    width: ['100%', '100%', '100%', '100%', '238px'],
    '& > div': {
      borderBottom: `1px solid ${defaultTheme.border.color.lightGray}`,
    },
  }),
);

export const SetNum = styled.div((props: { isRemoved: boolean }) =>
  mq({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: defaultTheme.font.size.s,
    padding: `${defaultTheme.spacing.s} 0`,
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      '& > button': {
        width: '40px',
        height: '40px',
        marginLeft: defaultTheme.spacing.xxl,
      },
    },
    span: {
      opacity: props.isRemoved ? defaultTheme.button.opacity.disabled : 1,
    },
  }),
);
